import { render, staticRenderFns } from "./MoResetPasswordConfirmPage.vue?vue&type=template&id=3844ddf8&scoped=true&"
import script from "./MoResetPasswordConfirmPage.vue?vue&type=script&lang=js&"
export * from "./MoResetPasswordConfirmPage.vue?vue&type=script&lang=js&"
import style0 from "./MoResetPasswordConfirmPage.vue?vue&type=style&index=0&id=3844ddf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3844ddf8",
  null
  
)

export default component.exports